import { useCallback, useState } from 'react'

import { remove } from '@/services/remove/delete'

export const useRemove = () => {
  const [isLoading, setIsLoading] = useState(false)

  const removeItems = useCallback(
    async ({
      idsItens,
      alteradoPor,
      motivoRemocao
    }: {
      idsItens: string[]
      alteradoPor: string
      motivoRemocao: string
    }) => {
      try {
        setIsLoading(true)
        const response = await remove({
          idsItens,
          alteradoPor,
          motivoRemocao
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { removeItems, isLoading }
}
